"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var laravel_echo_1 = __importDefault(require("laravel-echo"));
require("pusher-js");
var KEY_DEVELOPMENT = "d5a9d866d1113a6d25de";
var KEY_PRODUCTION = "ed02a95977ed0cfa01ef";
var echo = new laravel_echo_1.default({
    broadcaster: "pusher",
    key: (!process.env.NODE_ENV || process.env.NODE_ENV === "development") ? KEY_DEVELOPMENT : KEY_PRODUCTION,
    cluster: "eu",
    forceTLS: true,
    namespace: null
});
exports.default = echo;
exports.channels = require("../channels.json");
exports.events = require("../events.json");
